module.exports = __webpack_public_path__ + "static/media/igait.ed35e28d.svg";